import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { cn } from "@/lib/utils";
import React from "react";

export interface TabConfig<T extends string = string> {
  value: T;
  label: string;
  content: React.ReactNode;
}

interface SettingsTabsProps<T extends string> {
  tabs: readonly TabConfig<T>[];
  activeTab: T;
  onTabChange: (value: T) => void;
}

function SettingsTabs<T extends string>({
  tabs,
  activeTab,
  onTabChange,
}: SettingsTabsProps<T>) {
  return (
    <Tabs
      value={activeTab}
      onValueChange={(val) => onTabChange(val as T)}
      className="w-full"
    >
      <div className="scrollbar-none mb-8 w-full overflow-x-auto">
        <TabsList className="inline-flex min-w-max items-center whitespace-nowrap rounded-xl bg-gray-100/60 p-1">
          {tabs.map((tab) => (
            <TabsTrigger
              key={tab.value}
              value={tab.value}
              className={cn(
                "shrink-0 rounded-lg px-6 py-2 text-xs font-bold outline-none transition-all",
                "text-gray-500 hover:text-gray-900",
                "data-[state=active]:bg-white data-[state=active]:text-black data-[state=active]:shadow-sm"
              )}
            >
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>
      </div>

      {tabs.map((tab) => (
        <TabsContent
          key={tab.value}
          value={tab.value}
          className="mt-0 outline-none"
        >
          {tab.content}
        </TabsContent>
      ))}
    </Tabs>
  );
}

export default SettingsTabs;
